import { useMediaQuery } from '@material-ui/core';

const useLandscape = (): boolean => {
    return useMediaQuery('(orientation:landscape)');
};

export default useLandscape;
